module.exports = __webpack_public_path__ + "img/coderas.7ceadbf7.png";